import { thunk, action } from "easy-peasy";
import companyProfileService from "./service";

export default {
    getCompanyProfile: thunk(async (actions, p) => {
        try {
            const companyProfile = await companyProfileService.getCompanyProfile(p);
            actions._setCompanyProfile(companyProfile);
        } catch (err) {
            // set a simple boolean for the UI and keep the debug message separately
            actions._setCompanyProfileError(true);
            actions._setCompanyProfileDebug(err.message || 'Unknown error');
        }
    }),
    getFeatureFlags: thunk(async (actions, p, { getState }) => {
        const state = getState();
        if (state.featureFlagsLoaded) {
            return;
        }
        try {
            const featureFlags = await companyProfileService.getFeatureFlags(p);
            actions._setFeatureFlags(featureFlags);
        } catch (err) {

        }
    }),
    _setCompanyProfile: action((state, payload) => {
        state.companyProfile = payload;
        state.companyProfileLoaded = true;
        state.companyProfileError = false;
        state.companyProfileDebugError = null;
    }),
    _setFeatureFlags: action((state, payload) => {
        state.isMoldovaEnvironment = payload.isMoldovaEnvironment;
        state.featureFlagsLoaded = true;
    }),
    _setCompanyProfileError: action((state, payload) => {
        state.companyProfileError = payload;
    }),
    _setCompanyProfileDebug: action((state, payload) => {
        state.companyProfileDebugError = payload;
    })
};
